import Vue from "vue";
import { Locale } from "vant";
import VueI18n from "vue-i18n";
import NATIVE from "@/utils/native";
import store from "../store";
// vant语言包
import zhCN from "vant/es/locale/lang/zh-CN";
import enUS from "vant/es/locale/lang/en-US";
import thTH from "vant/es/locale/lang/th-TH";
import msMY from "./vant-locales/ms-MY";
import viVN from "./vant-locales/vi-VN";

Vue.use(VueI18n);

const vantLocales = {
  "zh-CN": zhCN,
  "en-US": enUS,
  "th-TH": thTH,
  "ms-MY": msMY,
  "vi-VN": viVN
};
function loadLocaleMessages() {
  const locales = require.context("./locales", true, /[A-z0-9-_,\s]+\.json/i);
  const messages = {};
  locales.keys().forEach(key => {
    const matched = key.match(/([A-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = {
        ...locales(key)
      };
    }
  });
  return messages;
}
const messages = loadLocaleMessages();
const language = "zh-CN"; // 初始化默认中文
const i18n = new VueI18n({
  locale: language,
  fallbackLocale: "en-US",
  messages
});

// 设置vant 语言包
Locale.use("locale", vantLocales[language]);

// 异步设置货币单位
NATIVE.getAppCurrencyInfo().then(appCurrencyInfoStr => {
  const infoArr = appCurrencyInfoStr.split("|");
  store.commit("app/setDecimalPlaces", infoArr[0], { root: true });
  store.commit("app/setSeparator", infoArr[1], { root: true });
});

window._I18N = i18n;
export default i18n;



// WEBPACK FOOTER //
// ./src/i18n/i18n.js